import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-1ejqzs0-0"
})(["display:flex;width:100%;", " button{min-width:fit-content;width:fit-content;&.floor-plan{svg{width:20px;height:20px;}}&.video{svg{path{fill:", ";}}}}", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.gap(3);
}, function (props) {
  return props.theme.colors.blueDianne;
}, function (props) {
  return props.isMobile && "\n      justify-content: flex-start;\n      margin-block: ".concat(props.theme.space(6), ";\n      padding-inline: ").concat(props.theme.space(5), ";\n\n      @supports not (padding-inline: 10px) {\n        padding-left: ").concat(props.theme.space(5), ";\n        padding-right: ").concat(props.theme.space(5), ";\n      }\n  ");
});